import { render } from "./myDepositOrder.vue?vue&type=template&id=274aaeb8&scoped=true"
import script from "./myDepositOrder.vue?vue&type=script&lang=js"
export * from "./myDepositOrder.vue?vue&type=script&lang=js"

import "./myDepositOrder.vue?vue&type=style&index=0&id=274aaeb8&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-274aaeb8"]])

export default __exports__